import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const HoverFade = ({ front, overlay, className }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={className}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ position: "relative" }}
    >
      {/* Always show the front */}
      <div className="w-full h-full">
        {front}
      </div>

      {/* Overlay fades in on hover */}
      <AnimatePresence>
        {hovered && (
          <motion.div
            key="overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="absolute inset-0 w-full h-full"
          >
            {overlay}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default HoverFade;
